// extracted by mini-css-extract-plugin
export default {"pageNotFoundContainer":"PageNotFound_pageNotFoundContainer__kNcAn"};